
import {Component, Vue} from 'vue-property-decorator';
import dayjs from 'dayjs';
import {AdminOverview as Overview} from '@/data/dao/LogsDao';

/**
 * Onglet « Accueil » de l'administration : indicateurs importants tirés des autres onglets,
 * chaque carte menant à l'onglet correspondant. Un seul appel (/admin/overview) renvoie les nombres
 * et les premiers éléments de chaque carte.
 */
@Component({})
export default class AdminOverview extends Vue {
  overview: Overview = null;
  error = false;

  mounted(): void {
    this.$dao.logs.getOverview()
        .then((overview) => this.overview = overview)
        .catch(() => this.error = true);
  }

  tabRoute(tab: string): { name: string; params: Record<string, string> } {
    return {name: 'administration', params: {tab}};
  }

  fromNow(date: Date): string {
    return dayjs(date).fromNow();
  }

  formatDate(date: string): string {
    return dayjs(date).format('DD.MM.YYYY');
  }
}
